import React, { useState, useEffect } from 'react';
import '../../styles/Notifications.css';
import { getNotifications, markNotificationRead } from '../../services/api';

function Notifications() {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await getNotifications();
        setNotifications(data);
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
      }
    };
    fetchNotifications();
  }, []);

  const markAsRead = async (id) => {
    try {
      await markNotificationRead(id);
      setNotifications(notifications.map(n => n.id === id ? { ...n, read: true } : n));
    } catch (err) {
      console.error('Failed to mark notification as read:', err);
    }
  };

  const clearAll = () => {
    setNotifications([]);
    // Optionally add API call to clear notifications on server
  };

  return (
    <div className="sp-notifications">
      <h2 className="sp-notifications-title">Notifications</h2>
      <button className="sp-clear-btn" onClick={clearAll}>Clear All</button>
      <ul className="sp-notifications-list">
        {notifications.map((notification) => (
          <li key={notification.id} className={`sp-notification-item ${notification.read ? 'sp-read' : ''}`}>
            <span className="sp-notification-message">{notification.message}</span>
            <span className="sp-notification-date">{notification.date}</span>
            {!notification.read && (
              <button className="sp-read-btn" onClick={() => markAsRead(notification.id)}>Mark as Read</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Notifications;